import PropTypes from "prop-types"
import React, { Component } from "react"
import ReactModal from "react-modal"
import { t, tError } from "../../i18next"
import { Link } from "react-router-dom"

export default class DamageCasePage extends Component {
  static propTypes = {
    submitPending: PropTypes.bool,
    submitError: PropTypes.shape({
      graphqlErrors: PropTypes.arrayOf(PropTypes.object.isRequired),
      networkError: PropTypes.object,
    }),
    dismissSubmitCaseError: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.node,
  }

  render() {
    return (
      <div className={`damage-case-page ${this.props.className}`}>
        {this.props.children}
        {this.renderModal()}
      </div>
    )
  }

  renderModal = () => {
    const { submitPending, submitError } = this.props
    if (submitError) {
      return this.renderErrorModal(submitError)
    } else if (submitPending) {
      return this.renderSubmittingModal()
    } else {
      return null
    }
  }

  renderErrorModal = ({ graphqlErrors, networkError }) => {
    return (
      <ReactModal isOpen={true} overlayClassName="pretty-modal-overlay" className="pretty-modal damage-case-modal">
        <h1 className="title">{t("damageCase.submissionFailed")}</h1>

        {networkError && <p className="error">{tError("common", { code: "network_error" })}</p>}

        {(graphqlErrors || []).map((error, idx) => (
          <p className="error" key={`${idx} ${error.code}`}>
            {tError("damage-case", error)}
          </p>
        ))}

        <div className="button-group">
          <button onClick={this.props.dismissSubmitCaseError}>OK</button>
        </div>
      </ReactModal>
    )
  }

  renderSubmittingModal = () => {
    return (
      <ReactModal isOpen={true} overlayClassName="pretty-modal-overlay" className="pretty-modal damage-case-modal">
        <h1 className="title">{t("damageCase.submissionPending")}</h1>

        <progress />

        <div className="button-group">
          <Link to="/case/unsent">
            <button>{t("damageCase.submissionToBackground")}</button>
          </Link>
        </div>
      </ReactModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/damage-case/DamageCasePage.js